import { defineMessages } from 'react-intl';

export default defineMessages({
  signLanguageTitle: {
    id: 'cboard.components.Board.SignLanguageViewer.signLanguageTitle',
    defaultMessage: 'Sign Language'
  },
  closeViewer: {
    id: 'cboard.components.Board.SignLanguageViewer.closeViewer',
    defaultMessage: 'Close sign language viewer'
  },
  generatingAnimation: {
    id: 'cboard.components.Board.SignLanguageViewer.generatingAnimation',
    defaultMessage: 'Generating sign language animation...'
  }
});
